import styled from 'styled-components';
import { DarkBlue, LigthGray, DarkGray } from '../../assets/colors';

export const fieldStyle = {
    background: 'rgba(246, 246, 246, 0.6)',
    border: `2px solid ${DarkBlue}`,
    borderRadius: "5px",
    height: "35px",
    width: '100%',
}
  
export const fieldDisabledStyle = {
    background: LigthGray,
    border: `3px solid ${DarkGray}`
}

export const FieldLabel = styled.div`
    display: flex;
    flex-direction: row; 
    align-items: center;
    position: relative !important;
`